export default "__VITE_ASSET__B7mHI20U__"